<template>
  <div class="common-layout">
    <el-container type="flex">
      <el-header></el-header>
      <el-container>
        <el-aside width="100%">

<!--           <el-row>
            <el-col :span="12"><div >1</div></el-col>
            <el-col :span="12"><div >2</div></el-col>
          </el-row> -->

          <el-table :data="tableData" border stripe style="width: 100%">
            <el-table-column prop="date" label="发布日期" sortable min-width="15%"> </el-table-column>
            <!-- <el-table-column label="软件列表"> -->
              <el-table-column prop="name" label="名称" min-width="20%"> </el-table-column>
              <!-- <el-table-column label="地址"> -->
                <!-- <el-table-column prop="province" label="省份" width="120">
                </el-table-column>
                <el-table-column prop="city" label="市区" width="120">
                </el-table-column> -->
                <el-table-column prop="address" label="说明" min-width="50%"> </el-table-column>
                <!-- <el-table-column prop="zip" label="邮编" width="120"> </el-table-column> -->
              <!-- </el-table-column> -->
            <!-- </el-table-column> -->
            <el-table-column prop="link" min-width="15%">

              <template v-slot="scope">
                <el-link :href="scope.row.link" target="_blank">

                  <el-button type="primary" style="margin-bottom: 10px;"> 下载 </el-button>

                </el-link>

              </template>
        

            </el-table-column>
          </el-table>



        </el-aside>

        <!-- <el-container>
          <el-main>网页的主要区域 {{ msg }}</el-main>
        </el-container> -->
      </el-container>
      <el-footer></el-footer>
    </el-container>
  </div>
  </template>
  <script>


  export default {
    name: 'MainPage',
    props: {
      msg: String
    },
    data() {
      return {
        tableHeight: 500, // 初始值
        tableWhite:800,
        tableData: [
          { 
            date: '2025-11-17',
            name: '视频音频合并大师2025版',
            link:'http://www.heroren.com/xjdown/xjspyphb2025.exe',
            address: '视频音频合并大师2025版是一款功能强大的视频音频合并工具，它可以帮助您将几乎所有流行的视频格式，'+

                    '如： MP4、3GP、MKV,MOV,VOB、DAT、VCD、DVD、SVCD、ASF、MPEG、WMV、DivX、XviD、AVI、FLV、'+

                    '+MKV等视频文件 加上自己好听歌曲或音乐 合并为一个独立的视频。格式支持几乎所有的主流视频格式，还'+

                    '可以自定义视频尺寸。',
          },
          {
            date: '2025-11-17',
            name: '视频合并大师2025版',
            link:'http://www.heroren.com/xjdown/sphbds2025.exe',
            address: '视频合并大师2025版是一款功能强大的视频合并工具， 它可以帮助您将几乎所有流行的视频格式，'+

                    '如： MP4、3GP、MKV,MOV,VOB、DAT、VCD、DVD、SVCD、ASF、MPEG、WMV、DivX、 XviD、AVI、FLV、'+

                    'MKV等视频文件合并为一个独立的视频。格式支持几乎所有的主流视频格式，'+

                    '还可以自定义视频尺寸。',
          },
          {
            date: '2025-11-17',
            name: '图片转视频精灵2025版',
            link:'http://www.heroren.com/xjdown/xjpic2video.exe',
            address: '图片转视频精灵2025版是一款功能强大的图片转视频工具，它可以将图片文件加上自己好听歌曲或'+

                      '音乐合并为一个独立的视频，每一张图片都可以独立编辑添加文字备注。格式支持几乎所有的主流'+

                      '视频格式，还可以自定义视频尺寸。视频动画场景效果有100多种。肯定能满足您的要求！'+

                      '比如孩子的成长记录，生活的点点滴滴，旅游时的珍贵回忆，用此软件把视频加上自己喜欢的音乐合并一起'+

                      '来保存，是不是很方便啊！',
          },

          {
            date: '2025-11-17',
            name: '网页/视频声音提取大师2025版',
            link:'http://www.heroren.com/xjdown/xjsytq2025.exe',
            address: '网页/视频声音提取大师2025版是一款功能强大的音频提取工具，无论是电脑里的视频，还是网页中播放的视频，'+

                      '只要能播放，只要有声音，都能给您提取出来!'+

                      '平时在看电影的时候，突然觉得一个插曲很好听、某一段视频的声音特别精彩，但是网上又找不到音源怎么'+

                      '办？ 本软件，可以帮助用户方便的提取各种视频中的声音，而且它还支持将提取后的文件直接转换为MP3格式。',
          },

          {
            date: '2025-11-17',
            name: '视频图片提取大师2025版',
            link:'ttp://www.heroren.com/xjdown/xjsptptqds2025.exe',
            address: '视频图片提取大师 2025版是一款功能强大的图片提取工具，能将视频里的每一帧都提取出来，保存成图片'+

                    '格式！出去旅游、朋友聚会，二人世界、孩子成长....等等这些精彩的生活组成部分，您是否只存了视频而'+

                    '没有图片，很是遗憾，别急，视频图片提取大师给你想要的！',
          },

          {
            date: '2025-11-17',
            name: '摄像头录像大师2025版',
            link:'http://www.heroren.com/xjdown/xjsxtlxds2025.exe',
            address: '摄像头录像大师2025版一款实用的摄像头监控软件，为很多小商店或家庭提供了最经济的监控解决方案，使用普通USB聊天摄像头'+

                    '来实现实时监控，摄录清晰，输出格式选择性大，可以显示通道、时间码，视频文件自定义删除时间，节省'+

                    '您的硬盘空间，简单实用专业。',
          },







        ],
      }
    },
    



  }
  </script>
  <style>
  .el-header,
    .el-footer {
      background-color: white;
      color: var(--el-text-color-primary);
      text-align: center;
      line-height: 20px;
    }
    .el-aside {
      background-color: white;
      color: var(--el-text-color-primary);
      text-align: center;
      line-height: 20px;
    }
    .el-main {
      background-color: #e9eef3;
      color: var(--el-text-color-primary);
      text-align: center;
      line-height: 160px;
    }
    body > .el-container {
      margin-bottom: 40px;
    }
    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
      line-height: 260px;
    }
    .el-container:nth-child(7) .el-aside {
      line-height: 320px;
    }
  </style>
  